// Built-ins
import React from "react";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";

// Modules / Functions
import { Card, ListGroup } from "react-bootstrap";
import { Button, Grid, Input } from "semantic-ui-react";
import ReactPaginate from "react-paginate";
import AddPrivateTransferModal from "../../modals/create/add_private_transfer_modal";
import ReactCountryFlag from "react-country-flag";
import axios from "axios";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

// CSS
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// Icons / Images
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import NoDataToShowImage from "../../../images/generic/no_results_found.png";
import { BsTable, BsTablet, BsInfoSquare } from "react-icons/bs";

// Global Variables
import {
  paginationOptions,
  headers,
  loader,
  pageHeader,
  forbidden,
  restrictedUsers,
  countryToCode,
} from "../../global_vars";

// Variables
window.Swal = Swal;

const GET_PRIVATE_TRANSFERS =
  "https://groupplan.gr/api/data_management/all_private_transfers/";

let cross_style = {
  color: "red",
  fontSize: "1em",
};

let tick_style = {
  color: "green",
  fontSize: "1.4em",
};

const enabledFilterOptions = {
  true: "Yes",
  false: "No",
};

const tariffFilterOptions = {
  true: "Yes",
  false: "No",
}

const rowStyle = (row) => {
  const style = {};
  if (row.enabled === false) {
    style.color = "red";
  }
  return style;
};

function formatLocation(location) {
  // Check if the input is undefined, null, or "N/A"
  if (location === undefined || location === null || location === "N/A") {
    return "Invalid location";
  }

  // Split the string by ' >>> ' and trim any leading/trailing spaces
  const parts = location.split(' >>> ').map(part => part.trim());

  // Check if we have at least two parts
  if (parts.length >= 2) {
    const country = parts[1]; // Second part is the country
    const city = parts[2] || ''; // Third part is the city, if available
    return city ? `${country} - ${city}` : country;
  }

  return "Invalid location";
}


function getCountry(location) {
  // Check if the input is undefined, null, or "N/A"
  if (location === undefined || location === null || location === "N/A") {
    return "Invalid location";
  }

  // Split the string by ' >>> ' and trim any leading/trailing spaces
  const parts = location.split(' >>> ').map(part => part.trim());

  // Check if we have at least two parts (continent and country)
  if (parts.length >= 2) {
    return parts[1]; // Return the second part, which is the country
  }

  return "Invalid location";
}

const normalizeUrl = (url) => {
  if (!url) return '';
  const trimmed = url.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

const columns = [
  {
    dataField: "id",
    text: "ID",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => (
      <>
        <a
          href={"/data_management/private_transfer/" + row.id}
          className={row.enabled ? "" : "cnclled"}
          basic
          id="cell_link"
        >
          {row.name}
        </a>
      </>
    ),
  },
  {
    dataField: "region",
    text: "Region",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => (
      <>
        {row.region ? 
          <>
          {getCountry(row.region) !== 'Invalid Location' ? 
            <ReactCountryFlag
              countryCode={countryToCode[getCountry(row.region)]}
              svg
              style={{ width: "2.3em", height: "2.3em", marginRight: 10 }}
              title={getCountry(row.region)}
            />
          :
          <>
          </>
          }
            {formatLocation(row.region)}
          </>
          :
          'N/A'
        }
      </>
    ),
  },
  {
    dataField: "tel",
    text: "Tel details",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => (
      <>
        {row.tel ? 
          row.tel.split(" - ")[0] === "" ||
          row.tel.split(" - ")[0] === "None" ? (
            <>
              <strong>Tel : </strong> N/A
            </>
          ) : (
            <>
              <strong>Tel : </strong> {row.tel.split(" - ")[0]}
            </>
          )
          :
          'N/A'
        }
      </>
    ),
  },
  {
    dataField: "address",
    text: "Address",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => (
      <> {row.email === "None" ? "N/A" : <>{row.email}</>} </>
    ),
  },
  {
    dataField: "website",
    text: "Website",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => (
      <>
        {row.website && row.website !== "N/A" && row.website !== "None" ? (
          <a
            href={normalizeUrl(row.website)}
            target="_blank"
            rel="noreferrer"
            basic
            id="cell_link"
            className={row.enabled ? "" : "cnclled"}
          >
            {row.website}
          </a>
        ) : (
          "N/A"
        )}
      </>
    ),
  },

  {
    dataField: "place",
    text: "Place",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "enabled",
    text: "Enabled",
    sort: true,
    filter: selectFilter({
      options: enabledFilterOptions,
    }),
    formatter: (cell, row) => (
      <>
        {row.enabled ? (
          <TiTick style={tick_style} />
        ) : (
          <ImCross style={cross_style} />
        )}
      </>
    ),
  },
    {
    dataField: "tariff",
    text: "Tariffs",
    sort: true,
    filter: selectFilter({
      options: tariffFilterOptions,
    }),
    formatter: (cell, row) => (
      <>
        {row.tariff ? (
          <TiTick style={tick_style} />
        ) : (
          <ImCross style={cross_style} />
        )}
      </>
    ),
  },
];

const defaultSorted = [
  {
    dataField: "id",
    order: "desc",
  },
];

const NoDataToShow = () => {
  return <img src={NoDataToShowImage} alt={""} className="fill" />;
};

// url path = '/all_private_transfers'
class AllPrivateTransfers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      all_private_transfers: [],
      is_loaded: false,
      selectedView: "table",
      selectedName: null,
      currentPage: 1,
      private_transfersPerPage: 10,
      searchValue: "",
      totalFilteredPrivateTransfers: 0,
      lastClickTime: 0,
      forbidden: false,
    };
  }

  async fetchPrivateTransfers() {
    try {
      if (restrictedUsers().includes(localStorage.getItem("user"))) {
        this.setState({
          forbidden: true,
        });
        return; // exit function if user is restricted
      }

      const res = await axios.get(GET_PRIVATE_TRANSFERS, {
        headers: headers,
      });

      const allPrivateTransfers = res.data.all_private_transfers;
      const filteredPrivateTransfers = allPrivateTransfers.filter(
        (private_transfer) =>
          private_transfer.name
            .toLowerCase()
            .includes(this.state.searchValue.toLowerCase())
      );

      this.setState({
        all_private_transfers: allPrivateTransfers,
        totalFilteredPrivateTransfers: filteredPrivateTransfers.length,
        is_loaded: true,
      });
    } catch (e) {
      if (e.response && e.response.status === 401) {
        this.setState({
          forbidden: true,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An unknown error has occurred.",
        });
      }
    }
  }

  componentDidMount() {
    this.fetchPrivateTransfers();
    if (window.innerWidth < 992) {
      this.setState({
        selectedView: "tablet",
      });
    } else {
      this.setState({
        selectedView: "table",
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchValue !== this.state.searchValue) {
      this.fetchPrivateTransfers();
    }
  }

  setView = (view) => {
    this.setState({
      selectedView: view,
    });
  };

  handlePageChange = (selectedPage) => {
    this.setState({
      currentPage: selectedPage.selected + 1,
    });
  };

  setSelectedName = (name) => {
    this.setState({
      selectedName: name,
    });
  };

  handleDoubleTap = (private_transfer_id) => {
    const { lastClickTime } = this.state;
    const currentTime = new Date().getTime();
    const tapTimeDifference = currentTime - lastClickTime;

    if (tapTimeDifference < 300) {
      window.location.href =
        "/data_management/private_transfer/" + private_transfer_id;
    }

    this.setState({ lastClickTime: currentTime });
  };

  render() {
    const {
      all_private_transfers,
      currentPage,
      searchValue,
      totalFilteredPrivateTransfers,
    } = this.state;

    // Filter the all_private_transfers array based on the search term
    const filteredPrivateTransfers = all_private_transfers.filter(
      (private_transfer) =>
        private_transfer.name.toLowerCase().includes(searchValue.toLowerCase())
    );

    // Calculate the index range of private_transfers for the current page from the filtered array
    const indexOfLastCoachOperator =
      currentPage * this.state.private_transfersPerPage;
    const indexOfFirstCoachOperator =
      indexOfLastCoachOperator - this.state.private_transfersPerPage;
    const currentPrivateTransfers = filteredPrivateTransfers.slice(
      indexOfFirstCoachOperator,
      indexOfLastCoachOperator
    );
    return (
      <>
        <NavigationBar />
        <div className="mainContainer">
          {pageHeader("all_private_transfers")}
          <div className='container'>
            <h3 className='dox_h3'>Autocomplete Searching: </h3>
            <Autocomplete
              options={this.state.all_private_transfers.map((private_transfer) => private_transfer.id + ") " + private_transfer.name)}
              className={"select_airport"}
              style={{ width: 300 }}
              filterOptions={(options, { inputValue }) => {
                const lowercasedInput = inputValue.toLowerCase();
                const words = lowercasedInput.split(' '); // Split input into words
                return options.filter(option => {
                  const lowercasedOption = option.toLowerCase();
                  return words.every(word => lowercasedOption.includes(word));
                });
              }}
              onChange={(event, value) => {
                window.open("/data_management/private_transfer/" + value.split(") ")[0], '_blank');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Private Transfer"
                  variant="outlined"
                />
              )}
            />
          </div>
          <div style={{ marginLeft: 20, width: 80, borderRadius: 10 }}>
            <Button
              id="table_icon"
              style={{
                padding: 6,
                margin: 2,
                backgroundColor:
                  this.state.selectedView === "table" ? "#e3e3e3" : "",
              }}
              onClick={() => this.setView("table")}
            >
              <BsTable
                style={{
                  color: "#F3702D",
                  fontSize: "1.5em",
                }}
              />
            </Button>
            <Button
              id="tablet_icon"
              style={{
                padding: 6,
                margin: 2,
                backgroundColor:
                  this.state.selectedView === "tablet" ? "#e3e3e3" : "",
              }}
              onClick={() => this.setView("tablet")}
            >
              <BsTablet
                style={{
                  color: "#F3702D",
                  fontSize: "1.5em",
                }}
              />
            </Button>
          </div>
          {this.state.forbidden ? (
            <>{forbidden("All Private Transfers")}</>
          ) : this.state.is_loaded ? (
            this.state.selectedView === "table" ? (
              <>
                <ToolkitProvider
                  keyField="id"
                  data={this.state.all_private_transfers}
                  columns={columns}
                  search
                  noDataIndication={<NoDataToShow />}
                  bootstrap4
                  condensed
                  defaultSorted={defaultSorted}
                  exportCSV
                >
                  {(props) => (
                    <div>
                      <BootstrapTable
                        {...props.baseProps}
                        id="all_private_transfers_table"
                        pagination={paginationFactory(paginationOptions)}
                        hover
                        bordered={false}
                        striped
                        rowStyle={rowStyle}
                        filter={filterFactory()}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                <AddPrivateTransferModal redir={true} />
              </>
            ) : (
              <>
                <div style={{ marginLeft: 20 }}>
                  <Input
                    icon="search"
                    placeholder="Search Name..."
                    style={{ margin: 0 }}
                    onChange={(e) =>
                      this.setState({ searchValue: e.target.value })
                    }
                    value={this.state.searchValue}
                  />
                </div>
                <Grid columns={2} stackable style={{ marginLeft: 20 }}>
                  <Grid.Row>
                    <Grid.Column width={6}>
                      {currentPrivateTransfers.map((private_transfer) => (
                        <>
                          <Button
                            color={this.state.selectedName === private_transfer.name ? "blue" : "vk"}
                            onClick={(e) => {
                              this.setSelectedName(e.target.innerText);
                              this.handleDoubleTap(private_transfer.id);
                            }}
                            style={{ width: 300, margin: 10 }}
                          >
                            {private_transfer.name}
                          </Button>
                          <br />
                        </>
                      ))}
                    </Grid.Column>
                    <Grid.Column width={6}>
                      {this.state.all_private_transfers
                        .filter((private_transfer) => private_transfer.name === this.state.selectedName)
                        .map((private_transfer) => (
                          <>
                            <Card width={4}>
                              <Card.Header>
                                <BsInfoSquare
                                  style={{
                                    color: "#F3702D",
                                    fontSize: "1.5em",
                                    marginRight: "0.5em",
                                  }}
                                />
                                Private Transfer Information
                              </Card.Header>
                              <Card.Body>
                                <ListGroup>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>ID</div>
                                    <div className={"info_span"}>
                                      {private_transfer.id}
                                    </div>
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>Name</div>
                                    <div className={"info_span"}>
                                      <a
                                        href={"/data_management/private_transfer/" + private_transfer.id}
                                        className={ private_transfer.enabled ? "" : "cnclled"}
                                        basic
                                        id="cell_link"
                                      >
                                        {private_transfer.name}
                                      </a>
                                    </div>
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>
                                      Tel Details
                                    </div>
                                    <div className={"info_span"}>
                                      {private_transfer.tel.split(" - ")[0] === "" || private_transfer.tel.split(" - ")[0] === "None" ? (
                                        <>
                                          <strong>Tel : </strong> N/A <br />
                                        </>
                                      ) : (
                                        <>
                                          <strong>Tel : </strong> {private_transfer.tel.split(" - ")[0]}<br />
                                        </>
                                      )}
                                      {private_transfer.tel.split(" - ")[1] === "" || private_transfer.tel.split(" - ")[1] === "None" ? (
                                        ""
                                      ) : (
                                        <>
                                          <strong>Tel2 : </strong>
                                          {private_transfer.tel.split(" - ")[1]}
                                          <br />
                                        </>
                                      )}
                                      {private_transfer.tel.split(" - ")[2] === "" || private_transfer.tel.split(" - ")[2] === "None" ? (
                                        ""
                                      ) : (
                                        <>
                                          <strong>Tel3 : </strong>
                                          {private_transfer.tel.split(" - ")[2]}
                                          <br />
                                        </>
                                      )}
                                    </div>
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>Address</div>
                                    <div className={"info_span"}>
                                      {private_transfer.address}
                                    </div>
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>Address</div>
                                    <div className={"info_span"}>
                                      {private_transfer.email === "None" && private_transfer.email === "" ? (
                                        "N/A"
                                      ) : (
                                        <>{private_transfer.email}</>
                                      )}
                                    </div>
                                  </ListGroup.Item>
                                  <ListGroup.Item>
                                    <div className={"info_descr"}>
                                      Lat / Lng
                                    </div>
                                    <div className={"info_span"}>
                                      {private_transfer.lat_lng}
                                    </div>
                                  </ListGroup.Item>
                                </ListGroup>
                              </Card.Body>
                              <Card.Footer></Card.Footer>
                            </Card>
                          </>
                        ))}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <ReactPaginate
                  previousLabel={"<-"}
                  className="react-pagination"
                  nextLabel={"->"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(totalFilteredPrivateTransfers / this.state.private_transfersPerPage)}
                  marginPagesDisplayed={0}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageChange}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages react-pagination"}
                  activeClassName={"active"}
                />
                <AddPrivateTransferModal redir={true} />
              </>
            )
          ) : (
            loader()
          )}
        </div>
        <Footer />
      </>
    );
  }
}

export default AllPrivateTransfers;
